export default {
  makeTreePlugin: () => null,
};
